import { FormatOptions } from '@/components/AnalyticsDashboard/formatter'
import { ChartComponent } from '..'
import { Limits } from './limits'

export const createTooltip = (
  limits: Limits,
  yFormat: FormatOptions,
  xFormat?: FormatOptions
): ChartComponent[] => [
  {
    type: 'tooltip',
    xLimits: limits.x,
    yLimits: limits.y,
    yFormat,
    xFormat
  }
]
